module.exports = [
  require('./create_magen'),
]
